import { createServer } from 'miragejs';

import CardRoutes from './routes/cards';
import AccountRoutes from './routes/Accounts';
import ReportRoutes from './routes/reports';
import UsersRoutes from './routes/users';
import TransactionRoutes from './routes/transactions';
import DataStoreRoutes from './routes/dataStore';
import AccountingIntegrationRoutes from './routes/accountingIntegration';
import EverydayRewardsRoutes from './routes/everydayRewards';
import CashRoutes from './routes/cash';

export default function startMockServer() {
  return createServer({
    routes() {
      // eslint-disable-next-line no-undef
      this.urlPrefix = `${import.meta.env.VITE_APIM_BASE_URL ?? import.meta.env.REACT_APP_APIM_BASE_URL}`;
      // eslint-disable-next-line no-undef
      const baseDomain = `${import.meta.env.VITE_API_BASE_URL ?? import.meta.env.REACT_APP_API_BASE_URL}`;
      // eslint-disable-next-line no-undef
      const authDomain = `${import.meta.env.VITE_B2C_INSTANCE ?? import.meta.env.REACT_APP_B2C_INSTANCE}`;

      CardRoutes.call(this);
      AccountRoutes.call(this);
      ReportRoutes.call(this);
      UsersRoutes.call(this);
      TransactionRoutes.call(this);
      DataStoreRoutes.call(this);
      AccountingIntegrationRoutes.call(this);
      EverydayRewardsRoutes.call(this);
      CashRoutes.call(this);

      // pass through all requests that don't match above
      this.passthrough(`${baseDomain}/**`);
      this.passthrough(`${authDomain}/**`);

      this.passthrough();
    },
  });
}
